// Handles video data with or without undo/redo
import type { RootState } from 'js/src/libs/RootState';

export function getVideoData(state: RootState) {
    return ((state.undoable || {}).present || {}).video_data;
}

export function userCanPerformUndoAction(state: RootState) {
    return state.undoable.past.length > 0;
}

export function userCanPerformRedoAction(state: RootState) {
    return state.undoable.future.length > 0;
}
